module.exports = {
  init: () => {
    $(window).on("scroll", function() {
      if ($(".pagemenu").length >= 1) {
        var headerBottom = $("header.header").offset().top + $("header.header").outerHeight() + $(".pagemenu-wrapper").outerHeight();
        var divBottom = $(".pagemenu-wrapper").offset().top + $(".pagemenu-wrapper").outerHeight();
        if (divBottom < headerBottom) {
          if ($("header.header .pagemenu").length == 0) {
            $(".pagemenu")
              .clone(true)
              .appendTo("header.header");
          }
        } else {
          $("header.header .pagemenu").detach();
        }
      }
      onScroll();
    });

    function onScroll(event) {
      var offSet = isHeaderSticky() ? 80 : 30;
      var scrollPos = $(document).scrollTop();

      $("header .pagemenu a").each(function() {
        var currLink = $(this);

        var refElement = $(currLink.attr("href"));

        if (refElement.offset().top - $("header .pagemenu").height() - offSet <= scrollPos && refElement.offset().top + refElement.outerHeight(true) > scrollPos) {
          $(".pagemenu a").removeClass("pagemenu-item--active");
          currLink.addClass("pagemenu-item--active");
        } else {
          currLink.removeClass("pagemenu-item--active");
        }
      });
    }

    function isHeaderSticky() {
      return $(".mediaquery--tablet").is(":visible");
    }

    $("a.pagemenu-item").click(function(e) {
      var offSet = isHeaderSticky() ? 80 : 30;
      if ($(this).hasClass("pagemenu-item--first") === false) {
        $("header.header").addClass("header--hidden");
        $("html,body").animate({ scrollTop: $($(this).attr("href")).offset().top + 1 - ($(".pagemenu").height() + offSet) }, "slow", function() {
          setTimeout(function() {
            $("header.header").removeClass("header--hidden");
          }, 100);
        });
      } else {
        $("html,body").animate({ scrollTop: 0 }, "slow");
      }

      return false;
    });
  }
};
